import { render, staticRenderFns } from "./ImovelView.vue?vue&type=template&id=3799e83f&scoped=true&"
import script from "./imovel.js?vue&type=script&lang=js&"
export * from "./imovel.js?vue&type=script&lang=js&"
import style0 from "./ImovelView.vue?vue&type=style&index=0&id=3799e83f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799e83f",
  null
  
)

export default component.exports